
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UIButton from "@/components/button/ui-button.vue";
  import PaymentCardForm from "@/components/payment/PaymentCardForm.vue";
  import FormError from "@/components/common/FormError.vue";

  import PaymentCardDataChangeEventPayload from "@/entities/PaymentCardDataChangeEventPayload";

  @Component({
    components: {
      UIButton,
      PaymentCardForm,
      FormError,
    },
  })
  export default class AddPaymentCardForm extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly buttonText!: string;
    @Prop({ type: Boolean, default: false }) readonly outerProcessing!: boolean;
    @Prop({ type: String, default: undefined }) readonly outerErrorMessage?: string;

    card: stripe.elements.Element | null = null;
    cardDataValid: boolean = false;
    processing: boolean = false;
    errorMessage: string = "";

    get error(): string {
      return this.outerErrorMessage || this.errorMessage;
    }

    get isProcessing(): boolean {
      return this.outerProcessing || this.processing;
    }

    onPaymentCardDataChange(payload: PaymentCardDataChangeEventPayload): void {
      const { complete, card } = payload;
      this.card = card;
      this.cardDataValid = complete;
    }

    async addCard(): Promise<void> {
      if (!this.cardDataValid || this.processing || !this.card) {
        return;
      }

      this.processing = true;

      try {
        const { token, error } = await this.$stripe.createToken(this.card);

        if (error) {
          throw error;
        }

        this.$emit("addCard", { token: token!.id });
      } catch (error) {
        const { message } = error;

        this.errorMessage = message;
      } finally {
        this.processing = false;
      }
    }

    get isErrorShown(): boolean {
      return this.error.length > 0;
    }
  }
